import { useState, useEffect } from "react";
import { Quote } from "lucide-react";

export default function EventSection() {
  const images = [
    "/assets/Foto1.jpg",
    "/assets/Foto2.jpg",
    "/assets/Foto3.webp",
    "/assets/Foto4.jpg",
    "/assets/Foto5.jpg",
    "/assets/Foto6.jpg",
    "/assets/Foto7.webp",
    "/assets/Foto8.jpg",
    "/assets/Foto9.jpg",
    "/assets/Foto10.webp",
    "/assets/Foto11.webp",
    "/assets/Foto12.webp"
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <section id="evento" className="bb-section relative bg-black py-20">
      <div className="bb-container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          <div className="lg:col-span-7">
            <span className="bb-eyebrow" style={{ color: "var(--bb-primary)" }}>L'Evento</span>
            <h2 className="bb-display text-5xl md:text-7xl lg:text-8xl mt-5 leading-[0.95] uppercase">
              IL RING DOVE<br />
              LA TUA BIRRA<br />
              <span style={{ color: "var(--bb-primary)" }}>DIVENTA LEGGENDA.</span>
            </h2>

            {/* TESTO SINTETIZZATO E AGGIORNATO */}
            <div className="mt-10 space-y-6 text-zinc-300 text-base md:text-lg leading-relaxed max-w-2xl font-light">
              <p>
                Più di una gara, un'esigenza. Il <strong style={{ color: "var(--bb-primary)" }}>Beer Battle</strong> nasce per colmare un vuoto e dare una casa all’homebrewing nel Lazio.
              </p>
              <p>
                Un progetto creato da <strong style={{ color: "var(--bb-primary)" }}>Valentino e Marco</strong> che trasforma la competizione in un’opportunità di unione: uno spazio dove la passione trova voce e analisi tecnica.
              </p>
              <p>
                Ospitato da <strong style={{ color: "var(--bb-primary)" }}>Hilltop Brewery</strong>, l'appuntamento è una tradizione dal 2023. Un rito annuale nato dall'esigenza di incontrarsi, confrontarsi e brindare insieme.
              </p>
            </div>

            <div className="mt-12 p-8 border-l-2 relative bg-zinc-900/20" style={{ borderColor: "var(--bb-primary)" }}>
              <Quote className="absolute -top-4 -left-4 opacity-50" size={36} style={{ color: "var(--bb-primary)" }} fill="currentColor" />
              <p className="text-xl md:text-2xl text-zinc-100 italic leading-relaxed">
                "La scheda tecnica è la nostra guida, ma la condivisione è l’unica vera vittoria di ogni homebrewer."
              </p>
              <div className="mt-5 bb-eyebrow" style={{ color: "var(--bb-primary)" }}>— Valentino & Marco</div>
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden border border-zinc-800 shadow-2xl group">
              {images.map((img, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-1000 ease-in-out ${
                    index === currentImage ? "opacity-100 scale-100" : "opacity-0 scale-105"
                  }`}
                >
                  <img
                    src={img}
                    alt="Evento Beer Battle"
                    className="w-full h-full object-cover grayscale"
                  />
                  <div className="absolute inset-0 bg-black/50" /> 
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80" />
                </div>
              ))}

              {/* BADGE AGGIORNATO AL 2013 */}
              <div className="absolute bottom-0 left-0 px-8 py-6 z-20" style={{ background: "var(--bb-primary)", color: "#000" }}>
                <div className="bb-display text-4xl leading-none">EST. 2023</div>
                <div className="text-[10px] font-bold uppercase tracking-[0.2em] mt-1">Beer Battle</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}